/**
 * Catálogo de las 9 colecciones NQORO (source: content/catalog-draft.json).
 * Usado por mega-menú, homepage grid, sitemap, SEO.
 *
 * Cuando FASE 4 (data layer) esté completa, esto se hidrata desde Drizzle.
 * Por ahora es estático para no bloquear UI.
 */

export interface Collection {
  slug: string;
  order: number;
  nameEs: string;
  nameEn: string;
  subtitleEs: string;
  subtitleEn: string;
  category:
    | 'joyeria'
    | 'indumentaria'
    | 'bolsos'
    | 'traje-de-bano'
    | 'sombreros'
    | 'textil-hogar'
    | 'esencias'
    | 'libros'
    | 'arte';
}

export const collections: readonly Collection[] = [
  {
    slug: 'codigo-aureo',
    order: 1,
    nameEs: 'Ē — Código Áureo',
    nameEn: 'Ē — Golden Code',
    subtitleEs: 'joya',
    subtitleEn: 'jewel',
    category: 'joyeria',
  },
  {
    slug: 'nouveau',
    order: 2,
    nameEs: 'Nouvēau',
    nameEn: 'Nouvēau',
    subtitleEs: 'indumentaria',
    subtitleEn: 'indumentary',
    category: 'indumentaria',
  },
  {
    slug: 'camelot',
    order: 3,
    nameEs: 'Camēlot',
    nameEn: 'Camēlot',
    subtitleEs: 'bolso',
    subtitleEn: 'bag',
    category: 'bolsos',
  },
  {
    slug: 'melusine',
    order: 4,
    nameEs: 'Mēlusine',
    nameEn: 'Mēlusine',
    subtitleEs: 'traje de baño',
    subtitleEn: 'swimsuit',
    category: 'traje-de-bano',
  },
  {
    slug: 'eter',
    order: 5,
    nameEs: 'Ēter',
    nameEn: 'Ēter',
    subtitleEs: 'sombrero',
    subtitleEn: 'hat',
    category: 'sombreros',
  },
  {
    slug: 'hedone',
    order: 6,
    nameEs: 'Hedonē',
    nameEn: 'Hedonē',
    subtitleEs: 'tela · almohadón',
    subtitleEn: 'fabric · cushion',
    category: 'textil-hogar',
  },
  {
    slug: 'eupheme',
    order: 7,
    nameEs: 'Euphemē',
    nameEn: 'Euphemē',
    subtitleEs: 'esencia',
    subtitleEn: 'essence',
    category: 'esencias',
  },
  {
    slug: 'memoir',
    order: 8,
    nameEs: 'Mēmoir',
    nameEn: 'Mēmoir',
    subtitleEs: 'libro · caja',
    subtitleEn: 'book · box',
    category: 'libros',
  },
  {
    slug: 'artefacto',
    order: 9,
    nameEs: 'Artēfacto',
    nameEn: 'Artēfacto',
    subtitleEs: 'arte',
    subtitleEn: 'art',
    category: 'arte',
  },
] as const;

export function getCollection(slug: string): Collection | undefined {
  return collections.find((c) => c.slug === slug);
}
